import React from 'react'

import {useEnrollInProgramMutation} from '@progyny/generated/graphql'

const EMOTIONAL_WELLBEING_PROGRAMS = [
  'pregnancy-emotional-support-program',
  'postpartum-emotional-support-program',
  'menopause-emotional-support-program',
]

interface UseProgramEnrollmentOptions {
  programId: string | undefined
  programSlug: string
  isEnrolled: boolean
  onSuccess: () => void
}

export const useProgramEnrollment = ({
  programId,
  programSlug,
  isEnrolled,
  onSuccess,
}: UseProgramEnrollmentOptions) => {
  const [enrollInProgram, {loading: enrolling}] = useEnrollInProgramMutation()
  const [showDisclaimerModal, setShowDisclaimerModal] = React.useState(false)

  const requiresDisclaimer = EMOTIONAL_WELLBEING_PROGRAMS.includes(programSlug)

  const performEnrollment = async () => {
    try {
      const result = await enrollInProgram({
        variables: {
          programId: programId as string,
          disclaimerAcknowledged: requiresDisclaimer ? true : undefined,
        },
      })

      if (result.data?.enrollInProgram?.success) {
        setShowDisclaimerModal(false)
        onSuccess()
      }
    } catch (err) {
      console.error('Enrollment error:', err)
    }
  }

  const handleEnroll = async () => {
    if (requiresDisclaimer && !isEnrolled) {
      setShowDisclaimerModal(true)
      return
    }
    await performEnrollment()
  }

  const handleDisclaimerAcknowledge = () => {
    performEnrollment()
  }

  const handleDisclaimerClose = () => {
    setShowDisclaimerModal(false)
  }

  return {
    enrolling,
    requiresDisclaimer,
    showDisclaimerModal,
    setShowDisclaimerModal,
    handleEnroll,
    handleDisclaimerAcknowledge,
    handleDisclaimerClose,
  }
}
